import { render, staticRenderFns } from "./accountAuth.vue?vue&type=template&id=60d6a0a2&scoped=true"
import script from "./accountAuth.vue?vue&type=script&lang=js"
export * from "./accountAuth.vue?vue&type=script&lang=js"
import style0 from "./accountAuth.vue?vue&type=style&index=0&id=60d6a0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6a0a2",
  null
  
)

export default component.exports